import * as yup from 'yup';

export const schema = yup.object({
  des_tipo_dados: yup.string().required(),
  tamanho: yup.number().min(0).required(),
});
